<template>
  <iframe
          :src="url"
          allowfullscreen
          allow="vr;accelerometer;gyroscope;fullscreen">
  </iframe>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState('tours', ['tour360']),
      url () {
        return `${this.tour360.cloudPanoUrl}?mls=1`
      }
    }
  }
</script>
